import React from 'react';

import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { CoreLink, DynamicMediaItem } from '../../../../components';

import './style.scss';
import { SCREEN_NORMAL, SCREEN_WIDE } from '../../../../config/constants';

const ParagraphCardsCard = ({ entity, amount }) => {
  const card = entity.toJS();
  const media = card.field_media[0];
  const link = card.field_link[0];
  const uri = link.alias ?? link.uri;
  const title = card.field_link[0].title;
  const { width } = useWindowDimensions();
  const isNormal = width >= SCREEN_NORMAL && width < SCREEN_WIDE;
  const isWide = width >= SCREEN_WIDE;
  let aspectRatio = '2_3';

  if (amount === 2 && (isNormal || isWide)) {
    aspectRatio = '4_3';
  } else if (amount === 3 && (isNormal || isWide)) {
    aspectRatio = '3_4';
  }

  return (
    <CoreLink to={uri} className="Card moving-arrow--proxy">
      {media ? (
        <DynamicMediaItem className="Card__background" media={media} imageAspectRatio={aspectRatio} />
      ) : (
        <div className="Card__background Card__default" />
      )}
      <div className="Card__content">
        <h4 className="Card__content__title">
          <CoreLink to={uri} title={title} />
        </h4>
        <CoreLink to={uri} className="Card__content__arrow icon-arrow-right icon-before icon-after moving-arrow icon-variant-4" />
      </div>
    </CoreLink>
  );
};

export default ParagraphCardsCard;
